/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint, ZodTypes } from '../index';
import { z } from '../zod';

export const GetAuthenticationOAuth2Providers = {
  id: 'authentication.oauth2-providers.get',
  tag: 'Authentication',
  summary: 'Get OAuth2 providers',
  description: 'Retrieve the status of the OAuth2 providers',
  method: 'get',
  route: () => `/authentication/sso`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.record(ZodTypes.OAuth2Providers, z.boolean()),
        },
      },
    },
  },
} as const satisfies Endpoint;
